import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import InputNumber from '../InputNumber';
import Button from '../Button';

var Jump = /*#__PURE__*/function (_React$Component) {
  _inherits(Jump, _React$Component);

  var _super = _createSuper(Jump);

  function Jump() {
    var _this;

    _classCallCheck(this, Jump);

    _this = _super.apply(this, arguments);
    _this.state = {
      value: undefined
    };

    _this.handleChange = function (value) {
      _this.setState({
        value: value
      });
    };

    _this.handleJump = function () {
      var onChange = _this.props.onChange;
      onChange(_this.state.value);
    };

    return _this;
  }

  _createClass(Jump, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          allPages = _this$props.allPages;
      var value = this.state.value;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "\u5230\u7B2C"), /*#__PURE__*/React.createElement(InputNumber, {
        value: value,
        size: size,
        min: 1,
        max: allPages,
        onChange: this.handleChange,
        showOperator: false,
        isForceToZeroWhenEmpty: false,
        style: {
          display: 'inline-block'
        }
      }), /*#__PURE__*/React.createElement("span", null, "\u9875"), /*#__PURE__*/React.createElement(Button, {
        size: size,
        type: "hollow",
        onClick: this.handleJump
      }, "\u8DF3\u8F6C"));
    }
  }]);

  return Jump;
}(React.Component);

Jump.propTypes = {
  size: PropTypes.string,
  allPages: PropTypes.number,
  onChange: PropTypes.func
};
Jump.defaultProps = {
  size: 'normal',
  allPages: 1,
  onChange: undefined
};
export default Jump;